import React from 'react';
import cx from 'classnames';

import {
  Text,
} from 'spindl-shared-components';

import styles from './Initials.module.scss';
import usePresenter from './Initials.presenter';
import getProps from './Initials.props';
import { InitialsCombinedProps } from './types';

const Initials: React.FC<InitialsCombinedProps> = (props) => {
  const {
    type,
    className,
    classes,
    text,
  } = usePresenter(props);

  const variantName = `${type}`;
  const internalProps = getProps(variantName);
  const currentStyle = styles[`initials${variantName}`];

  let componentView;

  switch (variantName) {
    case 'Large':
    case 'Small': {
      componentView = (
        <div className={cx(currentStyle, className)}>
          <Text
            className={cx(styles.text, classes?.text)}
            {...internalProps.text}
            {...text}
          />
        </div>
      );
      break;
    }
    default:
      componentView = <div>�</div>;
      break;
  }

  return componentView;
};

export default Initials;
